import HttpResponse from '../../components/layouts/HttpResponse';

const InternalServerError = () => {
  return <HttpResponse number="500" text="Server error" />;
};

export default InternalServerError;
